import {useState} from 'react';
import {Form} from 'antd';
import {
  useRequestMenuOptionCustomHooks,
  useRequestMenuOptionEffects,
} from './RequestMenuButtonAndDrawer.hooks';
import {
  RequestMenuButtonAndDrawerContainerProps,
  RequestType,
} from './RequestMenuButtonAndDrawer.interfaces';
import RequestMenuButtonAndDrawerView from './RequestMenuButtonAndDrawer.view';
import {useGetRequestMenuButtonAndDrawerHandlers} from './RequestMenuButtonAndDrawer.handlers';

function RequestMenuButtonAndDrawerContainer({
  buttonAltStyle,
  buttonTitle,
  rerequestResource,
  showFindProgramOption,
  showProgramFinderOption,
  showRequestProgramOption,
  showRequestResourceOption,
}: RequestMenuButtonAndDrawerContainerProps) {
  const [form] = Form.useForm();

  const [bypassMenuSelection, setBypassMenuSelection] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [requestType, setRequestType] = useState<RequestType | undefined>(
    undefined
  );
  const [selectionIndex, setSelectionIndex] = useState(null);
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(true);
  const [isSubmitButtonLoading, setIsSubmitButtonLoading] = useState(false);
  const [onSubmit, setOnSubmit] = useState(null);
  const [showFooter, setShowFooter] = useState(false);
  const [total, setTotal] = useState(null);

  const {
    marketplaceLinkText,
    navigate,
    requestTypeOptions,
    userProgramPlanQuery,
    learningBudsQuery,
  } = useRequestMenuOptionCustomHooks({
    showRequestProgramOption,
    showRequestResourceOption,
  });

  const {
    handleReset,
    handleOnSubmit,
    handleOnClickMarketplaceLink,
    handleOnClickOption,
    handleOnClickProgramFinder,
    handleOnClickReset,
    handleOnCloseSuccess,
  } = useGetRequestMenuButtonAndDrawerHandlers({
    drawerVisible,
    form,
    navigate,
    onSubmit,
    setDrawerVisible,
    setRequestType,
    setSelectionIndex,
    setIsSubmitButtonDisabled,
    setIsSubmitButtonLoading,
    userProgramPlanQuery,
    learningBudsQuery,
  });

  useRequestMenuOptionEffects({
    bypassMenuSelection,
    formVisible,
    requestType,
    requestTypeOptions,
    selectionIndex,
    setBypassMenuSelection,
    setFormVisible,
    setIsSubmitButtonDisabled,
    setRequestType,
    setSelectionIndex,
    setShowFooter,
    showProgramFinderOption,
    setDrawerVisible,
    drawerVisible,
  });

  return (
    <RequestMenuButtonAndDrawerView
      buttonAltStyle={buttonAltStyle}
      buttonTitle={buttonTitle}
      drawerVisible={drawerVisible}
      form={form}
      formVisible={formVisible}
      handleOnClickMarketplaceLink={handleOnClickMarketplaceLink}
      handleOnClickOption={handleOnClickOption}
      handleOnClickProgramFinder={handleOnClickProgramFinder}
      handleOnClickReset={handleOnClickReset}
      handleOnCloseSuccess={handleOnCloseSuccess}
      isSubmitButtonDisabled={isSubmitButtonDisabled}
      isSubmitButtonLoading={isSubmitButtonLoading}
      marketplaceLinkText={marketplaceLinkText}
      navigate={navigate}
      onSubmit={handleOnSubmit}
      requestType={requestType}
      requestTypeOptions={requestTypeOptions}
      rerequestResource={rerequestResource}
      reset={handleReset}
      selectionIndex={selectionIndex}
      setDrawerVisible={setDrawerVisible}
      setIsSubmitButtonLoading={setIsSubmitButtonLoading}
      setOnSubmit={setOnSubmit}
      setRequestType={setRequestType}
      setTotal={setTotal}
      showFindProgramOption={showFindProgramOption}
      showFooter={showFooter}
      total={total}
    />
  );
}

export default RequestMenuButtonAndDrawerContainer;
